var map = {
	"./svg/comment-v2.svg": 758,
	"./svg/comment.svg": 137,
	"./svg/create-transfer-dialog.svg": 247,
	"./svg/end-meeting.svg": 613,
	"./svg/folder-docs.svg": 546,
	"./svg/folder.svg": 674,
	"./svg/hierarchical-table.svg": 170,
	"./svg/image.svg": 169,
	"./svg/meeting-end.svg": 573,
	"./svg/meeting.svg": 209,
	"./svg/merge.svg": 517,
	"./svg/no-links.svg": 947,
	"./svg/no-microphone.svg": 360,
	"./svg/no-video-camera.svg": 483,
	"./svg/package.svg": 234,
	"./svg/page-layout-empty.svg": 230,
	"./svg/preview.svg": 582,
	"./svg/search-no-results.svg": 763,
	"./svg/stamp.svg": 855,
	"./svg/table-simple.svg": 341,
	"./svg/tree.svg": 486,
	"./svg/upload.svg": 817,
	"./svg/user.svg": 107,
	"./svg/users.svg": 914,
	"./svg/wrong-2.svg": 0,
	"./svg/wrong.svg": 585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385;